<div class="file-view-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-lavuro m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-capitalize">
          Visualizacion de Archivo
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="m-0 p-0 file-view-modal-content">
    <div class="row">
      <div class="col-12 image-view">
        <img id="viewer" class="cursor-pointer" title="Click para acercar / ESC para alejar" [src]="file.fileUrl" />
      </div>
    </div>
  </div>

</div>